import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function Footer() {
  return (
    <footer style={{ backgroundColor: "#3f4e3a", color: "white" }} className="py-3 border-top">
      <div className="container">

        <div className="row">

          {/* LEFT - COMPANY */}
          <div className="col-6">
           <h6 className="fw-bold mb-2 mt-1" style={{ fontSize: "14px" }}>Company</h6>

            <ul className="list-unstyled" style={{ fontSize: "12px", lineHeight: "1.6" }}>
              <li><a href="/" className="text-white text-decoration-none">About Us</a></li>
              <li><a href="/" className="text-white text-decoration-none">Careers</a></li>
              <li><a href="/" className="text-white text-decoration-none">Blog</a></li>
              <li><a href="/" className="text-white text-decoration-none">Terms</a></li>
              <li><a href="/" className="text-white text-decoration-none">Privacy</a></li>
            </ul>
          </div>

          {/* RIGHT - CONTACT + SOCIAL */}
          <div className="col-6">

            {/* CONTACT */}
            <div className="mb-2">
              <h6 className="fw-bold mb-2 mt-1" style={{ fontSize: "14px" }}>Contact</h6>

             <div style={{ fontSize: "12px", lineHeight: "1.5" }}>
  
  <div className="d-flex align-items-start">
    <i className="bi bi-geo-alt-fill me-2" style={{ marginTop: "2px" }}></i>
    <div>
      AL244, Sector 2, Saltlake<br />
      Kolkata, 700091
    </div>
  </div>

  <div>
    <i className="bi bi-telephone-fill me-1"></i>
    <a href="tel:+919836904698" className="text-white text-decoration-none">
      9836904698
    </a>
  </div>

  <div>
    <i className="bi bi-envelope-fill me-1"></i>
    <a href="mailto:info@orbiit.com" className="text-white text-decoration-none">
      info@orbiit.com
    </a>
  </div>

</div>
            </div>

            {/* SOCIAL */}
            <div>
              <h6 className="fw-bold mb-2 mt-1" style={{ fontSize: "14px" }}>Social</h6>

              <div className="d-flex gap-3" style={{ fontSize: "18px" }}>
                <a href="/" className="text-white"><i className="bi bi-facebook"></i></a>
                <a href="/" className="text-white"><i className="bi bi-instagram"></i></a>
                <a href="/" className="text-white"><i className="bi bi-linkedin"></i></a>
              </div>
            </div>

          </div>

        </div>

        <hr className="my-2 border-white" />

        <div className="text-center" style={{ fontSize: "11px" }}>
          © {new Date().getFullYear()} Orrbiit. All Rights Reserved.
        </div>

      </div>
    </footer>
  );
}